import Typography from '@portalterreno/react-ui-core/Typography';

import StyledLink from './StyledLink';

export type OnBoardingNavigateProps = {
  navigateURL: string;
  navigationPrimaryText: string;
  navigationSecondaryText: string;
};

const OnBoardingNavigate: React.FC<OnBoardingNavigateProps> = ({
  navigateURL,
  navigationPrimaryText,
  navigationSecondaryText,
  ...rest
}) => {
  return (
    <div {...rest}>
      <Typography>
        {navigationPrimaryText}{' '}
        <StyledLink href={navigateURL}>{navigationSecondaryText}</StyledLink>
      </Typography>
    </div>
  );
};

export default OnBoardingNavigate;
